import { render, staticRenderFns } from "./CRS.vue?vue&type=template&id=37253577&"
import script from "./CRS.vue?vue&type=script&lang=js&"
export * from "./CRS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports